const convertUserMessageToBepFormat = (
  chatId,
  message,
  websiteLocation,
) => {
  return {
    customMessage: message,
    chatId,
    websiteLocation
  }
}

export { convertUserMessageToBepFormat }
